import { useState, useEffect,useRef } from "react";
import ReactDatetime from "react-datetime";
import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
  Col,
  FormGroup,
  InputGroup ,
  InputGroupAddon,
  InputGroupText ,
  Input
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import 'assets/css/themecustom-style.css';
import { useHistory,useParams,useLocation } from "react-router-dom";
const axios = require("axios");
import {usermanageService} from '../../services/usermanageService';
import {taskmanageService} from '../../services/taskmanageService';
import { ToastContainer, toast } from 'react-toastify';
import { clientmanageService } from "../../services/clientmanageService.js";
import Select from 'react-select';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {apiUrl} from '../../constant';
import {authtoken} from '../../global.js';

const SMEClients = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const success = queryParams.get('success');
  
  const user_info = JSON.parse(localStorage.getItem("user-info"));

  const history = useHistory();
  const healthcheckup = (clientId) =>{
    history.push({
      pathname: `healthcheckup/${clientId}`,
    });
  }
  const formatCurrency = (amount) => {
    const numericAmount = parseFloat(amount);

    if (numericAmount === 0 || isNaN(numericAmount)) {
        return '-';
    }
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    }).format(amount);
  };

  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [kpiloading, setKPILoading] = useState(false);
  const [openissueloading, setOpenIssueLoading] = useState(false);
  const [formInputData, setFormInputData] = useState([]);
const [state, setState] = useState({startDate:null,endDate:null});
const [statesend, setStatesend] = useState({startDate:null,endDate:null});
  function setEndDateRangeCustom(e,index,field){
    var month = e._d.getMonth() + 1;
    var date = e._d.getDate();
    var year = e._d.getFullYear();
    var dd = date + '-' + month + '-' + year;
    setStatesend({ ...statesend,endDate: dd });
    setState({ ...state,endDate: e });
  
    
  }
  function setStartDateRange(e,index){
    var month = e._d.getMonth() + 1;
    var date = e._d.getDate();
    var year = e._d.getFullYear();
    var dd = date + '-' + month + '-' + year;
    setStatesend({ ...statesend, startDate: dd })
    setState({ ...state, startDate: e })
  }
  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_list(index);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_list(prev);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_list(next);
  };
  const [maincategory,setMainCategory] = useState('xero');
  const getCatData = (title) =>{
    setMainCategory(title)
    get_list(1,'',title);
  }
  const get_list = async (pageNumber = 1,rowsPerPage='',cat=maincategory,client=clientsearch,subclient=selectedSubclients) => {
    clientmanageService.getSMEClients(pageNumber,rowsPerPage,cat,client,subclient).then((response) => {
      console.log(response.data)
        setdata(response.data.data.data);
        setCurrentPage(response.data.data.current_page);
        setLastPageData(response.data.data.last_page);
    });
  };
  const [category,setCategory] = useState('admin');
  const [openissueData,setOpenIssueData] = useState({});
  const getData = (title,pageNumber = 1,rowsPerPage='',cat=maincategory,client=clientsearch,subclient=selectedSubclients.value) =>{
    setCategory(title)
    if(title == 'kpi'){
      get_unique_companieslist()
    }
    if(title == 'open_issue' || title=='close_issue'){
      setOpenIssueLoading(true)
      clientmanageService.getOpenIssue(pageNumber,rowsPerPage,cat,client,subclient,title).then((response) => {
        setOpenIssueLoading(false)
        setOpenIssueData(response.data.data);
        
          // setCurrentPage(response.data.data.current_page);
          // setLastPageData(response.data.data.last_page);
      });
    }
  }
 
  const downloadfile = (path, name, extension) => {
    taskmanageService
      .download_file(path, name, extension)
      .then((response) => {});
  };
  
  useEffect(() => {
    if (success == 1) {
       toast.success(' Organization is connected successfully.');
    }
    if (success == 2) {
      toast.error(' Organization is not connected.');
   }
 }, [success]);
  const [xeroconnect, setxeroconnect] = useState(false);
  function xeroConnect(clientId) {
    if (confirm("Do you want to connect to account?")) {
      window.location.href = `${apiUrl}/xeroConnect?client_id=${clientId}`;
    }
  }
  

  const [xeroTenantname, setxeroTenantname] = useState('');
  function xeroconnectstatus(){
    clientmanageService.xeroconnectstatus().then((response)=>{

          if(response){
            setxeroconnect(true)
            setxeroTenantname(response.data.tenant_name)
          }
      });
  }
  function xeroDisconnect(clientId) {
    clientmanageService.xeroDisconnect(clientId).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.success)
        get_list();
      }else{
        toast.success(response.data.error)
      }
    });
  }

  function refreshData(clientId,index) {

    let temp_state = [...data];
    let temp_element = { ...temp_state[index] };
    temp_element.loading = true;
    temp_state[index] = temp_element;
    setdata(temp_state);
    clientmanageService.refreshData(clientId,statesend).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.success)
        get_list();
      }else{
        toast.success((response.data.error) ? response.data.error : "Something went wrong")
      }
      setLoading(false)
    });
  }

  function removeClient(clientId){
    // setLoading(true)
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        clientmanageService.removeSMEClient(clientId).then((response) => {
          if (response.status === 200) {
            const updatedData = data.filter((item) => item.uid !== clientId);
            setdata(updatedData);
            toast.success(response.data.success)
          }else{
            toast.success((response.data.error) ? response.data.error : "Something went wrong")
          }
          // setLoading(false)
        });
      }else{}
    });

  }

  const handlemaineditRow = (index,field) => {
    if(maincategory=='other'){
        let temp_state = [...data];
        let temp_element = { ...temp_state[index] };
        temp_element.editing = true;
        temp_element.field = field;
        temp_state[index] = temp_element;
        setdata(temp_state);
    }else {
      if(category=='admin'){
        let temp_state = [...data];
        
          let temp_element = { ...temp_state[index] };
          temp_element.editing = true;
          temp_element.field = field;
          temp_state[index] = temp_element;
          setdata(temp_state);
      }else if(category=='health'){
        let fieldArr = [
          'connected_bank_accounts',
          'no_of_credit_cards_connected',
          'unreconciled_transactions',
          'no_of_open_query',
          // 'hubdoc_connected',
          'unpaid_vat_amount',
          'is_vat_reconciled',
          'open_items',
          'paye_reconciled',
          'name',
          'bank_feed_expiry_date',
          'credit_card_feed_expiry'
        ];
        if (fieldArr.includes(field)) {
          let temp_state = [...data];
          console.log(temp_state)
          let temp_element = { ...temp_state[index] };
          temp_element.editing = true;
          temp_element.field = field;
          temp_state[index] = temp_element;
          setdata(temp_state);
        }
        
      }else{
        let notincludearr = [
          // 'unpaid_vat_amount',
          'vat_scheme',
          'vat_quarter_end',
          'year_end_date'
        ];
        if (!notincludearr.includes(field)) {
          let temp_state = [...data];
          let temp_element = { ...temp_state[index] };
          temp_element.editing = true;
          temp_element.field = field;
          temp_state[index] = temp_element;
          setdata(temp_state);
        }
        
      }
    }

  };
  const handleopenissueeditRow = (index,field) => {
  
        let temp_state = [...openissueData];
        let temp_element = { ...temp_state[index] };
        temp_element.editing = true;
        temp_element.edit_field = field;
        temp_state[index] = temp_element;
        setOpenIssueData(temp_state);
   

  };
  const editField = (value, field, id,index) => {
    clientmanageService.editUserDetails(value, field, id).then((response) => {
      if(response.status == 200){
          // toast.success(response.data.message);
           // Update the field and set editing to false
           let temp_state = [...data];
           let temp_element = { ...temp_state[index] };
           temp_element.editing = false;
           temp_element[field] = value;
           temp_state[index] = temp_element;
           setdata(temp_state);
      }else{
          toast.error(response.data.message);
      }
    });
  }
  const editOpenIssueField = (value, field, id,index) => {
    clientmanageService.editOpenIssueDetails(value, field, id).then((response) => {
      if(response.status == 200){
           toast.success(response.data.message);
           // Update the field and set editing to false
           let temp_state = [...openissueData];
           let temp_element = { ...temp_state[index] };
           console.log(temp_element)
           temp_element.editing = false;
           temp_element[field] = value;
           temp_state[index] = temp_element;
           setOpenIssueData(temp_state);
      }else{
          toast.error(response.data.message);
      }
    });
  }
  
  const headerStyle = {
    border: '2px solid #fff',
  };
  const manualDataStyle = {
    border: '2px solid #fff',
    color: '#1e90ff',
  };
  const xeroDataStyle = {
    border: '2px solid #fff',
    color: '#008000',
  };

  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  const [clientsearch, setclientsearch] = useState('');
  const [subclientOptions, setSubclientOptions] = useState([]);
  const [selectedSubclients, setSelectedSubclients] = useState([]);
  const get_unique_companieslist = () => {
    clientmanageService.getuniqueclient().then((response) => {
      setUniqueCompaniesData(response.data);
    });
  };
  const setclient = (e) => {
    setSelectedSubclients([])
    setclientsearch(e.value);
    subclientList(e.label);
  };
  

  const subclientList = (clientname = '') => {
    clientmanageService.getsubclientlist(clientname).then((response) => {
      if (response.status === 200) {
        const subclientOptions = response.data.map(res => ({
          value: res.sub_client,
          label: res.sub_client
        }));
        setSubclientOptions(subclientOptions);
      } else {
        toast.error('Something went wrong!');
      }
    });
  };
  const handleSubclientChange = (selectedOptions,search=0) => {
    setSelectedSubclients(selectedOptions || []);
   
    if(search == 1){
      get_list(1,'',maincategory,clientsearch, selectedOptions.value);
      // getData('open_issue')
    }
  };

  const current = new Date();
  const month = current.toLocaleString('en-US', { month: 'short' });
  const year = current.getFullYear();
  const [columns, setColumns] = useState([`${month} ${year}`]);
  
  const generateMonthLabels = (start, end) => {
    const labels = [];
    const current = new Date(start);
    console.log(current)
    while (current <= end) {
      const month = current.toLocaleString('en-US', { month: 'short' });
      const year = current.getFullYear();
      labels.push(`${month} ${year}`);
      current.setMonth(current.getMonth() + 1); // Increment by one month
    }
    return labels;
  };
  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const showFilterData = () => {
    setFormInputData([]);
    setKPILoading(true)
    if (statesend.startDate && statesend.endDate) {
      const start = parseDate(statesend.startDate);  // Convert date to proper format if needed
      const end = parseDate(statesend.endDate);      // Convert date to proper format if needed
      const monthLabels = generateMonthLabels(start, end);
      setColumns(monthLabels);
    }
  
    clientmanageService.getKPIData(clientsearch, selectedSubclients.value, statesend.startDate, statesend.endDate,maincategory)
      .then((response) => {
        if (response.status === 200) {
          setFormInputData(response.data);
          if(!response.data.status){
            toast.error(response.data.error)
          }
        } else {
          toast.error(response.data.error)
          setFormInputData([]);
        }
        setKPILoading(false)
      })
      .catch(error => {
        console.error("Error fetching KPI data:", error);
        setFormInputData([]);
        setKPILoading(false)
      });
  };
  const syncFilterData = () => {
   
    setKPILoading(true)
    // if (statesend.startDate && statesend.endDate) {
    //   const start = parseDate(statesend.startDate);  // Convert date to proper format if needed
    //   const end = parseDate(statesend.endDate);      // Convert date to proper format if needed
    //   const monthLabels = generateMonthLabels(start, end);
    //   setColumns(monthLabels);
    // }
  
    clientmanageService.syncKPIData(clientsearch, selectedSubclients.value, statesend.startDate, statesend.endDate,maincategory)
      .then((response) => {
        if (response.status === 200) {
          setFormInputData(response.data);
          toast.success(response.data.message);
        } else {
          toast.error(response.data.error)
          setFormInputData([]);
        }
        setKPILoading(false)
      })
      .catch(error => {
        console.error("Error fetching KPI data:", error);
        setFormInputData([]);
        setKPILoading(false)
      });
  };

  function showInsights()  {
    setKPILoading(true)
    clientmanageService.getKPIInsights(formInputData.data,statesend.startDate, statesend.endDate).then((response) => {
      setKPILoading(false)
    });
  }

  const profitabilityRatios = ["Gross Profit Margin", "Net Profit Margin", "Return on Assets (ROA)", "Return on Equity (ROE)"];
  const liquidityRatios = ["Current Ratio", "Quick Ratio", "Cash Ratio"];
  const leverageRatios = ["Debt-to-Equity Ratio", "Debt Ratio", "Interest Coverage Ratio"];
  const effieciencyRatios = ["Stock Turnover ratio", "Days sales outstanding", "Asset Turnover"];
  const trendAnalysis = ["Sales", "Overheads", "Aged receivables", "Aged Payables","Cash & Bank Balance","Directors' Loan Account","Pensions Payable","PAYE Payable","Long Term Liabilities"];
  function downloadReport(){
    
    clientmanageService.download_xclient_report(category,maincategory,clientsearch,selectedSubclients.value).then((response) => {
    
    });
  }
  function downloadKPIReport() {
    if (!formInputData?.data || !columns?.length) {
      toast.error("No data available to export!");
      return;
    }
  
    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height; // Page height for checking overflow
    let currentY = 20;
  
    // Report Title
    doc.setFontSize(16);
    doc.text("KPI Report", 14, currentY);
    currentY += 10;
  
    // Report Generation Date
    doc.setFontSize(12);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, currentY);
    currentY += 10;
  
    const sectionData = [
      { title: "Profitability Ratios", ratios: profitabilityRatios },
      { title: "Liquidity Ratios", ratios: liquidityRatios },
      { title: "Leverage (Solvency) Ratios", ratios: leverageRatios },
      { title: "Efficiency Ratios", ratios: effieciencyRatios },
      { title: "Trend Analysis", ratios: trendAnalysis },
    ];
  
    sectionData.forEach((section) => {
      // Check for page overflow and add new page if needed
      if (currentY + 20 >= pageHeight) {
        doc.addPage();
        currentY = 20; // Reset position on new page
      }
    
      // Add Section Title without Background
      currentY += 10; // Add spacing
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0); // Black text
      doc.text(section.title, 14, currentY); // No background rectangle
      currentY += 10;
    
      // Prepare Table Data
      const tableBody = section.ratios.map((ratio) => {
        const row = [ratio];
        columns.forEach((month) => {
          row.push(formInputData.data?.[ratio]?.[month] || "-");
        });
        row.push(formInputData.data?.[ratio]?.YTD || "-");
        return row;
      });
    
      // Add Section Table
      doc.autoTable({
        startY: currentY,
        head: [["Ratio", ...columns, "YTD"]],
        body: tableBody,
        theme: "striped",
        styles: { fontSize: 10 },
        headStyles: { fillColor: [22, 160, 133], textColor: 255 },
        margin: { top: 10, left: 14, right: 14 },
        pageBreak: "auto", // Automatically manage page breaks
      });
    
      // Update Y position
      currentY = doc.lastAutoTable.finalY + 10;
    });
    
  
    // Save PDF
    doc.save("KPI_Report.pdf");
  }
  useEffect(() => {
    get_unique_companieslist()
    get_list();
  
  }, []);
  const download_sample  = ()=>{
    clientmanageService.download_sample_for_other_client(category).then((response) => {
      
    });
  }
  const [file, setFile] = useState([]);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFile(file)
  };
  const importfile = ()=>{
    clientmanageService.other_client_import(category, file).then((response) => {
     
      if (response.status === 200) {
          toast.success(response.data.message);
          
      } else {
        
          if (response.data.file && response.data.file.length > 0 && response.data.file !='undefined') {
              toast.error(response.data.file[0]); // Display the specific error message for 'file' field
          } else {
            console.log("falls"+response.data.error)
            
            let err = (response.data.error && Array.isArray(response.data.error) && response.data.error.length > 0)
            ? response.data.error[0]  // Use the first error message in the array
            : "Something went wrong";
            console.log(err)
            toast.error(err)
          }
      }
  }).catch((error) => {console.log(error)
      toast.error(error);
  });
}
const [isScrolling, setIsScrolling] = useState(false);
let scrollTimer = null;

useEffect(() => {
  const handleScroll = () => {
    const scrollLeft = window.scrollX;

    if (scrollLeft > 0) {
      document.body.classList.add('scrolling');
    } else {
      document.body.classList.remove('scrolling');
    }
  };

  window.addEventListener('scroll', handleScroll);
  
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, []);
 useEffect(() => {
  const interval = setInterval(async () => {
    const syncingItems = data.filter((d) => d.python_flag === 1);
    if (syncingItems.length === 0) return; // nothing syncing, skip

    for (const item of syncingItems) {
      try {
        const res = await clientmanageService.getXeroClientData(item.user_id);
        if (res.status === 200 && res.data.data.length > 0) {
          const updatedInfo = res.data.data[0];

          // Update only the changed fields in the current state
          setdata((prevData) =>
            prevData.map((row) =>
              row.user_id === updatedInfo.user_id
                ? {
                    ...row,
                    unreconciled_transactions:
                      updatedInfo.unreconciled_transactions,
                    python_flag: updatedInfo.python_flag,
                  }
                : row
            )
          );
        }
      } catch (err) {
        console.error("Error checking job status for client", item.user_id, err);
      }
    }
  }, 15000); // check every 15 seconds

  return () => clearInterval(interval);
}, [data]);
console.log(formInputData)
  return (
    <>
    <Header />
    <Container className="mt--7" fluid >
   
          <Row className="mt-2">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center row">
                <div className="col-xl-3 col-md-2 col-xs-12">
                  <h3 className="mb-0" style={{ fontSize: "20px" }}>
                    Clients
                  </h3>
                  </div>
                  <div className="col-xl-3 col-md-3 col-xs-12">
                      <h3 className="clientformtag"> Client</h3>
                      <Select
                        className="input-group-alternative mb-3"
                        name="user_id"
                        options={uniquecompanieslist}
                        onChange={(e) => { setclient(e) }}
                        defaultValue={clientsearch}
                        searchable
                        isClearable={false}
                      />
                    </div>
                  
                      <div className="col-xl-3 col-md-3 col-xs-12">
                      <h3 className="clientformtag">Sub Client</h3>
                      <Select
                        className="input-group-alternative mb-3"
                        name="sub_client"
                        options={subclientOptions}
                        value={selectedSubclients}
                        onChange={(e) => { handleSubclientChange(e,1) }}
                        
                        placeholder="Select Sub Clients"
                      />
                    </div>
                  {/* <div className="col-xl-8 col-md-2 col-xs-12"> */}
                  <div className="col-xl-3 col-md-3 col-xs-12">
                        
                  <Col xl="12">
                  <Button
                      className="btn-icon-clipboard"
                      type="button"
                      onClick={(category == 'kpi') ? downloadKPIReport : downloadReport}
                      style={{textAlign:'center'}}
                      title="Download Report"
                    >
                    <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
                  </Button>
            </Col>
                        </div>
                        
                  {/* </div> */}
                </Row>
                <Row className="align-items-center row">
                  <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:maincategory=='xero' ? '#11cdef' : ''}} onClick={() => getCatData('xero')}>
                      Connected Clients
                  </button> 
                  <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:maincategory=='other' ? '#11cdef' : ''}} onClick={() => getCatData('other')}>
                      Other Clients
                  </button> 
                  <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:maincategory=='removed' ? '#11cdef' : ''}} onClick={() => getCatData('removed')}>
                      Archive 
                  </button> 
                </Row>
                <br></br>
                <Row className="align-items-center row">
                <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='admin' ? '#11cdef' : ''}} onClick={() => getData('admin')}>
        Admin
        </button> 
                <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='health' ? '#11cdef' : ''}} onClick={() => getData('health')}>
                Health check
        </button>
       
        <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='compliance' ? '#11cdef' : ''}} onClick={() => getData('compliance')}>
        Compliance
        </button> 
        {/* { maincategory=='xero' ? */}
        <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='kpi' ? '#11cdef' : ''}} onClick={() => getData('kpi')}>
        KPI's
        </button>
         {/* :''} */}
       { maincategory=='xero' ? 
       <>
         <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='open_issue' ? '#11cdef' : ''}} onClick={() => getData('open_issue')}>
        Open Issue
        </button> 
        <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='open_issue' ? '#11cdef' : ''}} onClick={() => getData('close_issue')}>
        Closed Issue
        </button> 
        </>
    :'' }
  
          </Row>
          <br></br>
              </CardHeader>
              { maincategory=='other' ?
              <div>
              <input
                type="file"
                accept=".xls,.xlsx"
                onChange={handleFileUpload}
                style={{width:'200px'}}
              />
             
            <Button color="primary" type="button" style={{background:"rgb(2, 199, 121)",border:"rgb(2, 199, 121)"}} onClick={importfile}>
            Import
            </Button>
             <a style={{color:'blue',cursor:'pointer'}} onClick={download_sample} download>Download Sample File</a><br></br>
                
              </div>:''}
              { category=='admin' ?
              <>
              
              <table className="align-items-center table-flush sticky-table-client stickytable" responsive>
              <thead className="red-row thead-light" style={{background: "#f6f4f4", borderLeft: "7px solid #737373",borderRadius: "4px 0px 0px 4px"}}>
                <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}> Status</th>
                <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Client Name</th>
                <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Sub-Client Name</th>
                <th scope="col" className="whitespace"  style={manualDataStyle}>Responsible Person</th>
                <th scope="col" className="whitespace"  style={manualDataStyle}>Is SOP documented</th>
                <th scope="col" className="whitespace"  style={manualDataStyle}>Recurring Meeting Scheduled</th>
                <th scope="col" className="whitespace"  style={manualDataStyle}>Last GC date</th>
                <th scope="col" className="whitespace"  style={manualDataStyle}>Feedback</th>
                <th scope="col" className="whitespace"  style={manualDataStyle}>Corient Outstanding Balance</th>
                <th scope="col" style={manualDataStyle} className="whitespace sticky-client-column-header">Is Hubdoc/ dext connected</th>
              </thead>
              <tbody className="scrollable-content">
                {data && data.length && data != null ? (
                  data.map((item, i) =>
                    item != undefined ? (
                      <>
                        <tr
                          className={
                            i % 2 == 0
                              ? "blue-row"
                              : 
                               "purple-row"
                              
                          }
                        >
                          <td style={{width:"10%"}} className="sticky-client-column">
                            {(item.connected == true) ? 
                              <> 
                              <span> Connected </span><br></br>
                              {(item.loading == true) ? 
                              <a style={{color:"#2FC3B9"}}  >Syncing.. </a>
                              :
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => refreshData(item.uid,i)}><i className="fas fa-refresh"> </i> Sync </a>
                              }
                              <br></br>
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroDisconnect(item.uid)}><i className="fas fa-close"> </i> Disconnect </a>
                              </>
                              : 
                            <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroConnect(item.uid)}><i className="fas fa-user"> </i> Connect </a>
                            }
                             {(maincategory != 'removed') ?  <><br></br><a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => removeClient(item.uid)}><i className="fas fa-trash"> </i> Archive </a></> : null }
                          </td>
                          <td className="sticky-client-column">{item.client_name}</td> 

                          <td className="sticky-client-column" onClick={() => handlemaineditRow(i, 'name')}>
  {item.editing && item.field === 'name' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.name}
      onBlur={(e) =>
        editField(e.target.value, 'name', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.name : ''}</span>
  )}
</td>
                          <td onClick={() => handlemaineditRow(i, 'responsible_person')}>
  {item.editing && item.field === 'responsible_person' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.responsible_person}
      onBlur={(e) =>
        editField(e.target.value, 'responsible_person', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.responsible_person : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'sop_documented')}>
  {item.editing && item.field === 'sop_documented' ? (
    <select
      className="form-control"
      defaultValue={item.sop_documented}
      onChange={(e) =>
        editField(e.target.value, 'sop_documented', item.uid, i)
      }
    >
      <option value="0" key="0" style={{ background: '#fff', color: '#000' }}>
        Select
      </option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item ? item.sop_documented : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'recurring_meeting')}>
  {item.editing && item.field === 'recurring_meeting' ? (
    <select
      className="form-control"
      defaultValue={item.recurring_meeting}
      onChange={(e) =>
        editField(e.target.value, 'recurring_meeting', item.uid, i)
      }
    >
      <option value="0" key="0" style={{ background: '#fff', color: '#000' }}>
        Select
      </option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item ? item.recurring_meeting : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'last_gc_date')}>
  {item.editing && item.field === 'last_gc_date' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.last_gc_date}
      onBlur={(e) =>
        editField(e.target.value, 'last_gc_date', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.last_gc_date : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'feedback')}>
  {item.editing && item.field === 'feedback' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.feedback}
      onBlur={(e) =>
        editField(e.target.value, 'feedback', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.feedback : ''}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'corient_due_amount')}>
  {item.editing && item.field === 'corient_due_amount' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.corient_due_amount}
      onBlur={(e) =>
        editField(e.target.value, 'corient_due_amount', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.corient_due_amount : '-'}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'hubdoc_connected')}>
  {item.editing && item.field === 'hubdoc_connected' ? (
    <select
      className="form-control"
      onChange={(e) => editField(e.target.value, 'hubdoc_connected', item.uid, i)}
      defaultValue={item.hubdoc_connected}
    >
      <option value="0">Select</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item.hubdoc_connected}</span>
  )}
</td>

                        </tr>
                      </>
                    ) : (
                      <></>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={3}>No Data Found!</td>
                  </tr>
                )}
              </tbody>
                </table></>
                : category=='health' ?
                <table className="align-items-center table-flush sticky-table-client stickytable" responsive >
                  <thead className="red-row thead-light" style={{background: "#f6f4f4", borderLeft: "7px solid #737373",borderRadius: "4px 0px 0px 4px"}}>
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}> Status</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Client Name</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Sub-Client Name</th>
                    {/* <th scope="col">Health checkup</th> */}
                    {user_info.department != 'BookKeeping'?
                    <>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>Last Month Turnover</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>YTD Turnover</th></>:null}
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>No of Bank accounts</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>No of Bank accounts connected</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>No of unreconciled bank transactions</th>
                    <th scope="col" className="whitespace" style={manualDataStyle}>Bank Feed Expiry date</th> 
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>No Of Credit cards</th>
                    <th scope="col" style={manualDataStyle} className="whitespace sticky-client-column-header">No Of Credit cards connected</th>
                    <th scope="col" style={manualDataStyle} className="whitespace">Credit card feed expiry date</th>
                    
                    {user_info.department === 'BookKeeping'?<>
                      <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle }>Last Traansaction reconciled date (Oldest)</th>
                      <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle }>Wallets</th>
                      <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle }>Loan Accounts-Capital on TAP</th>
                      <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle }>Stripe /Sales Channel Control Accounts</th>
                      <th scope="col" className="whitespace sticky-client-column-header" style={xeroDataStyle }>Drafts/Awating Approval Invoices/Bills</th>
                    </>:null}
                    <th scope="col" style={manualDataStyle} className="whitespace sticky-client-column-header">No of Open Query O/S for more than 1 month</th>
                    {user_info.department != 'BookKeeping'?<>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">Ap- No of Invoices O/S more than 90 days</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">Ap- Amt of Invoices O/S more than 90 days</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">AP- No. of open debits</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">AP- Open debits in Amt</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">AR- No of Invoices O/S more than 90 days</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">AR- Amt of Invoices O/S more than 90 days</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">AR- No of open credits</th>
                    <th scope="col" style={maincategory=='other' ? manualDataStyle : xeroDataStyle} className="whitespace sticky-client-column-header">AR- Open credits in Amt</th>
                    </>: null}
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>Unpaid VAT Amount</th>
                    <th scope="col" style={manualDataStyle} className="whitespace sticky-client-column-header">Is VAT reconciled?</th>
                    {user_info.department === 'BookKeeping'?
                      <th scope="col" className="whitespace sticky-client-column-header" style={xeroDataStyle }>CIS Applicable</th>:null}
                    {/* <th scope="col" style={manualDataStyle} className="whitespace sticky-client-column-header">Are there any open items</th> */}
                    <th scope="col" style={manualDataStyle} className="whitespace sticky-client-column-header">Is PAYE reconciled</th>
                    {user_info.department === 'BookKeeping'?
                    <>
                      <th scope="col" className="whitespace sticky-client-column-header" style={xeroDataStyle }>DLA Accounts</th>
                      <th scope="col" className="whitespace sticky-client-column-header" style={xeroDataStyle }>Mileage/Motor Vehicle</th>
                      <th scope="col" className="whitespace sticky-client-column-header" style={xeroDataStyle }>Intercompanies</th>
                    </>:null}
                  </thead>
                  <tbody className="scrollable-content">
                    {data && data.length && data != null ? (
                      data.map((item, i) =>
                        item != undefined ? (
                          <>
                            <tr
                              className={
                                i % 2 == 0
                                  ? "blue-row"
                                  : 
                                   "purple-row"
                                  
                              }
                            >
                             <td  className="sticky-client-column">
                            {(item.connected == true) ? 
                              <> 
                              <span> Connected </span><br></br>
                              {(item.loading == true) ? 
                              <a style={{color:"#2FC3B9"}}  >Syncing.. </a>
                              :
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => refreshData(item.uid,i)}><i className="fas fa-refresh"> </i> Sync </a>
                              }
                              <br></br>
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroDisconnect(item.uid)}><i className="fas fa-close"> </i> Disconnect </a>
                              </>
                              : 
                            <><a style={{cursor:"pointer",color:"#5d6cae",width:"50px"}}   onClick={() => xeroConnect(item.uid)}><i className="fas fa-user"> </i> Connect &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                            </>
                            }
                        
                          </td>
                          <td  className="sticky-client-column">{item.client_name}</td> 
                          <td className="sticky-client-column" onClick={() => handlemaineditRow(i, 'name')}>
  {item.editing && item.field === 'name' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.name}
      onBlur={(e) =>
        editField(e.target.value, 'name', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.name : ''}</span>
  )}
</td>
                              {/* <td style={{width:"10%"}}>  <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => healthcheckup(item.uid)}><i className="fas fa-eye"> </i>  </a>
                              </td> */}
                               {user_info.department != 'BookKeeping'?
                    <>
                    <td onClick={() => handlemaineditRow(i, 'last_month_turnover')}>
  {item.editing && item.field === 'last_month_turnover' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.last_month_turnover}
      onBlur={(e) => editField(e.target.value, 'last_month_turnover', item.uid, i)}
    />
  ) : (
    <span>
  { formatCurrency(item.last_month_turnover)}
</span>

  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ytd_turnover')}>
  {item.editing && item.field === 'ytd_turnover' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ytd_turnover}
      onBlur={(e) => editField(e.target.value, 'ytd_turnover', item.uid, i)}
    />
  ) : (
    
    <span>{formatCurrency(item.ytd_turnover)}</span>

  )}
</td></>:null}

<td onClick={() => handlemaineditRow(i, 'no_of_bank_accounts')}>
  {item.editing && item.field === 'no_of_bank_accounts' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.no_of_bank_accounts}
      onBlur={(e) => editField(e.target.value, 'no_of_bank_accounts', item.uid, i)}
    />
  ) : (
    <span>{item.no_of_bank_accounts > 0 ? item.no_of_bank_accounts : '-'}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'connected_bank_accounts')}>
  {item.editing && item.field === 'connected_bank_accounts' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.connected_bank_accounts}
      onBlur={(e) => editField(e.target.value, 'connected_bank_accounts', item.uid, i)}
    />
  ) : (
    <span>{item.connected_bank_accounts > 0 ? item.connected_bank_accounts : '-'}</span>
  )}
</td>


<td onClick={() => handlemaineditRow(i, 'unreconciled_transactions')}>
  {item.python_flag == 1 ? (
    <span>Syncing...</span>
  ) : item.editing && item.field === 'unreconciled_transactions' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.unreconciled_transactions}
      onBlur={(e) =>
        editField(e.target.value, 'unreconciled_transactions', item.uid, i)
      }
    />
  ) : (
    <span>{item.unreconciled_transactions ? item.unreconciled_transactions : '-'}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'bank_feed_expiry_date')}>
  {item.editing && item.field === 'bank_feed_expiry_date' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.bank_feed_expiry_date}
      onBlur={(e) =>
        editField(e.target.value, 'bank_feed_expiry_date', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.bank_feed_expiry_date : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'no_of_credit_cards')}>
  {item.editing && item.field === 'no_of_credit_cards' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.no_of_credit_cards}
      onBlur={(e) => editField(e.target.value, 'no_of_credit_cards', item.uid, i)}
    />
  ) : (
    <span>{item.no_of_credit_cards ? item.no_of_credit_cards : '-'}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'no_of_credit_cards_connected')}>
  {item.editing && item.field === 'no_of_credit_cards_connected' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.no_of_credit_cards_connected}
      onBlur={(e) => editField(e.target.value, 'no_of_credit_cards_connected', item.uid, i)}
    />
  ) : (
    <span>{item.no_of_credit_cards_connected ? item.no_of_credit_cards_connected : '-'}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'credit_card_feed_expiry')}>
  {item.editing && item.field === 'credit_card_feed_expiry' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.credit_card_feed_expiry}
      onBlur={(e) =>
        editField(e.target.value, 'credit_card_feed_expiry', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.credit_card_feed_expiry : ''}</span>
  )}
</td>

{user_info.department === 'BookKeeping'?<>
  <td onClick={() => handlemaineditRow(i, 'last_transaction_reconcile_date')}>
  {item.editing && item.field === 'last_transaction_reconcile_date' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.last_transaction_reconcile_date}
      onBlur={(e) =>
        editField(e.target.value, 'last_transaction_reconcile_date', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.last_transaction_reconcile_date : ''}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'wallet')}>
  {item.editing && item.field === 'wallet' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.wallet}
      onBlur={(e) =>
        editField(e.target.value, 'wallet', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.wallet : ''}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'loan_account_capital')}>
  {item.editing && item.field === 'loan_account_capital' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.loan_account_capital}
      onBlur={(e) =>
        editField(e.target.value, 'loan_account_capital', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.loan_account_capital : ''}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'channel_control_accounts')}>
  {item.editing && item.field === 'channel_control_accounts' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.channel_control_accounts}
      onBlur={(e) =>
        editField(e.target.value, 'channel_control_accounts', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.channel_control_accounts : ''}</span>
  )}
</td>
<td >
 
    <span>{item ? item.draft_approval_invoices : ''}</span>

</td>
</>
:null}
<td onClick={() => handlemaineditRow(i, 'no_of_open_query')}>
  {item.editing && item.field === 'no_of_open_query' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.no_of_open_query}
      onBlur={(e) => editField(e.target.value, 'no_of_open_query', item.uid, i)}
    />
  ) : (
    <span>{item.no_of_open_query > 0 ? item.no_of_open_query : '-'}</span>
  )}
</td>


{user_info.department != 'BookKeeping'?<>
<td onClick={() => handlemaineditRow(i, 'ap_invoice_overdue')}>
  {item.editing && item.field === 'ap_invoice_overdue' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ap_invoice_overdue}
      onBlur={(e) => editField(e.target.value, 'ap_invoice_overdue', item.uid, i)}
    />
  ) : (
    <span>{item.ap_invoice_overdue !=0 ? item.ap_invoice_overdue : '-'}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ap_amount_overdue')}>
  {item.editing && item.field === 'ap_amount_overdue' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ap_amount_overdue}
      onBlur={(e) => editField(e.target.value, 'ap_amount_overdue', item.uid, i)}
    />
  ) : (
    <span>{ formatCurrency(item.ap_amount_overdue) }</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ap_open_debits')}>
  {item.editing && item.field === 'ap_open_debits' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ap_open_debits}
      onBlur={(e) => editField(e.target.value, 'ap_open_debits', item.uid, i)}
    />
  ) : (
    <span>{item.ap_open_debits !=0 ? item.ap_open_debits : '-'}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ap_open_debits_amt')}>
  {item.editing && item.field === 'ap_open_debits_amt' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ap_open_debits_amt}
      onBlur={(e) => editField(e.target.value, 'ap_open_debits_amt', item.uid, i)}
    />
  ) : (
    <span>{formatCurrency(item.ap_open_debits_amt)}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ar_invoice_overdue')}>
  {item.editing && item.field === 'ar_invoice_overdue' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ar_invoice_overdue}
      onBlur={(e) => editField(e.target.value, 'ar_invoice_overdue', item.uid, i)}
    />
  ) : (
    <span>{item.ar_invoice_overdue !=0 ? item.ar_invoice_overdue : '-'}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ar_amount_overdue')}>
  {item.editing && item.field === 'ar_amount_overdue' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ar_amount_overdue}
      onBlur={(e) => editField(e.target.value, 'ar_amount_overdue', item.uid, i)}
    />
  ) : (
    <span>{formatCurrency(item.ar_amount_overdue)}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ar_open_credits')}>
  {item.editing && item.field === 'ar_open_credits' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ar_open_credits}
      onBlur={(e) => editField(e.target.value, 'ar_open_credits', item.uid, i)}
    />
  ) : (
    <span>{item.ar_open_credits !=0 ? item.ar_open_credits : '-'}</span>
  )}
</td>


<td onClick={() => handlemaineditRow(i, 'ar_open_credits_amt')}>
  {item.editing && item.field === 'ar_open_credits_amt' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.ar_open_credits_amt}
      onBlur={(e) => editField(e.target.value, 'ar_open_credits_amt', item.uid, i)}
    />
  ) : (
    <span>{formatCurrency(item.ar_open_credits_amt)}</span>
  )}
</td>
</>:null}
<td onClick={() => handlemaineditRow(i, 'unpaid_vat_amount')}>
  {item.editing && item.field === 'unpaid_vat_amount' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.unpaid_vat_amount}
      onBlur={(e) =>
        editField(e.target.value, 'unpaid_vat_amount', item.uid, i)
      }
    />
  ) : (
    <span>{item.unpaid_vat_amount !=0 ? item.unpaid_vat_amount : '-'}</span>
  )}
</td>
<td onClick={() => handlemaineditRow(i, 'is_vat_reconciled')}>
  {item.editing && item.field === 'is_vat_reconciled' ? (
    <select
      className="form-control"
      onChange={(e) => editField(e.target.value, 'is_vat_reconciled', item.uid, i)}
      defaultValue={item.is_vat_reconciled}
    >
      <option value="0">Select</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item.is_vat_reconciled}</span>
  )}
</td>
{user_info.department === 'BookKeeping'?
<td>
<span>{item.cis_applicable}</span>
</td>:null}
{/* <td onClick={() => handlemaineditRow(i, 'open_items')}>
  {item.editing && item.field === 'open_items' ? (
    <select
      className="form-control"
      onChange={(e) => editField(e.target.value, 'open_items', item.uid, i)}
      defaultValue={item.open_items}
    >
      <option value="0">Select</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item.open_items}</span>
  )}
</td> */}

<td onClick={() => handlemaineditRow(i, 'paye_reconciled')}>
  {item.editing && item.field === 'paye_reconciled' ? (
    <select
      className="form-control"
      onChange={(e) => editField(e.target.value, 'paye_reconciled', item.uid, i)}
      defaultValue={item.paye_reconciled}
    >
      <option value="0">Select</option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item.paye_reconciled}</span>
  )}
</td>
{user_info.department === 'BookKeeping'?
<>
<td><span>{item.dla_accounts}</span></td>
<td><span>{item.motor_vehicle}</span></td>
<td><span>{item.intercompanies}</span></td>
</>
:null}


                            </tr>
                          </>
                        ) : (
                          <></>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan={3}>No Data Found!</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                : category=='compliance' ?
                <table   className="align-items-center table-flush sticky-table-client stickytable" responsive>
                  <thead className="red-row" style={{background: "#f6f4f4", borderLeft: "7px solid #737373",borderRadius: "4px 0px 0px 4px"}}>
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}> Status</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Client Name</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Sub-Client Name</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : manualDataStyle}>Company number</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : manualDataStyle}>VAT Registration Number</th>
                    {/* <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Unpaid VAT Quarters</th> */}
                    {user_info.department == 'BookKeeping'?
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Last Filed VAT QE</th>
                    :null}
                     {user_info.department != 'BookKeeping'?
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : manualDataStyle}>VAT Gateway </th>:null}
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>VAT Scheme</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>Vat Quarter End</th>
                    {user_info.department == 'BookKeeping'?
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>CIS Registration Contractor/Subcontractor/Both</th>
                    :null}
                    {user_info.department != 'BookKeeping'?
                    <>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>MA Frequency</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Last MA Sent</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Month end checklist prepared</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={{ ...manualDataStyle,  minWidth: '100px',maxWidth: '100px',whiteSpace: 'nowrap' }}>MA Due Date</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>Year End Date</th>
                    </> :null}
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Last Year End Filled with Companies House</th>
                    {user_info.department != 'BookKeeping'?
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Opening Trial Balance Posted in Books for Last filled Accounts</th>
                    :null}
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Current Open Year End</th>
                    {user_info.department != 'BookKeeping'?
                    <>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Current Open Year End Due Date</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Accounts finalised by Corient</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Year-End  - Corient Due Date</th>
                    </>:null}
                  </thead>
                  <tbody className="scrollable-content">
                    {data && data.length && data != null ? (
                      data.map((item, i) =>
                        item != undefined ? (
                          <>
                            <tr
                              className={
                                i % 2 == 0
                                  ? "blue-row"
                                  : 
                                   "purple-row"
                                  
                              }
                            >
                              <td style={{width:"10%"}} className="sticky-client-column">
                              {(item.connected == true) ? 
                                <> 
                                <span> Connected </span><br></br>
                                {(item.loading == true) ? 
                              <a style={{color:"#2FC3B9"}}  >Syncing.. </a>
                              :
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => refreshData(item.uid,i)}><i className="fas fa-refresh"> </i> Sync </a>
                              }
                              <br></br>
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroDisconnect(item.uid)}><i className="fas fa-close"> </i> Disconnect </a>
                                </>
                                : 
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroConnect(item.uid)}><i className="fas fa-user"> </i> Connect </a>
                              }
                              
                            </td>
                            <td className="sticky-client-column">{item.client_name}</td> 
                            <td className="sticky-client-column" onClick={() => handlemaineditRow(i, 'name')}>
  {item.editing && item.field === 'name' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.name}
      onBlur={(e) =>
        editField(e.target.value, 'name', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.name : ''}</span>
  )}
</td>
                              <td onClick={() => handlemaineditRow(i, 'company_number')}>
  {item.editing && item.field === 'company_number' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.company_number}
      onBlur={(e) =>
        editField(e.target.value, 'company_number', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.company_number : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'vat_reg_number')}>
  {item.editing && item.field === 'vat_reg_number' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.vat_reg_number}
      onBlur={(e) =>
        editField(e.target.value, 'vat_reg_number', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.vat_reg_number : ''}</span>
  )}
</td>

{user_info.department == 'BookKeeping'?
  <td onClick={() => handlemaineditRow(i, 'last_filed_vat_qe')}>
  {item.editing && item.field === 'last_filed_vat_qe' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.last_filed_vat_qe}
      onBlur={(e) =>
        editField(e.target.value, 'last_filed_vat_qe', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.last_filed_vat_qe : ''}</span>
  )}
</td> : null}
{user_info.department != 'BookKeeping'?
<td onClick={() => handlemaineditRow(i, 'vat_gateway')}>
  {item.editing && item.field === 'vat_gateway' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.vat_gateway}
      onBlur={(e) =>
        editField(e.target.value, 'vat_gateway', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.vat_gateway : ''}</span>
  )}
</td>:null}

<td onClick={() => handlemaineditRow(i, 'vat_scheme')}>
  {item.editing && item.field === 'vat_scheme' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.vat_scheme}
      onBlur={(e) =>
        editField(e.target.value, 'vat_scheme', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.vat_scheme : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'vat_quarter_end')}>
  {item.editing && item.field === 'vat_quarter_end' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.vat_quarter_end}
      onBlur={(e) =>
        editField(e.target.value, 'vat_quarter_end', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.vat_quarter_end : ''}</span>
  )}
</td>
{user_info.department == 'BookKeeping'?
  <td onClick={() => handlemaineditRow(i, 'cis_reg_contractor')}>
  {item.editing && item.field === 'cis_reg_contractor' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.cis_reg_contractor}
      onBlur={(e) =>
        editField(e.target.value, 'cis_reg_contractor', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.cis_reg_contractor : ''}</span>
  )}
</td>:null}
{user_info.department != 'BookKeeping'?
<>
<td onClick={() => handlemaineditRow(i, 'ma_freq')}>
  {item.editing && item.field === 'ma_freq' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.ma_freq}
      onBlur={(e) =>
        editField(e.target.value, 'ma_freq', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.ma_freq : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'last_ma_sent')}>
  {item.editing && item.field === 'last_ma_sent' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.last_ma_sent}
      onBlur={(e) =>
        editField(e.target.value, 'last_ma_sent', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.last_ma_sent : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'month_end_checklist')}>
  {item.editing && item.field === 'month_end_checklist' ? (
    <select
      className="form-control"
      onChange={(e) =>
        editField(e.target.value, 'month_end_checklist', item.uid, i)
      }
      defaultValue={item.month_end_checklist}
    >
      <option value="0" key="0" style={{ background: '#fff', color: '#000' }}>
        Select
      </option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item ? item.month_end_checklist : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'ma_due_date')}>
  {item.editing && item.field === 'ma_due_date' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.ma_due_date}
      onBlur={(e) =>
        editField(e.target.value, 'ma_due_date', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.ma_due_date : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'year_end_date')}>
  {item.editing && item.field === 'year_end_date' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.year_end_date}
      onBlur={(e) =>
        editField(e.target.value, 'year_end_date', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.year_end_date : ''}</span>
  )}
</td>
</>:null}
<td onClick={() => handlemaineditRow(i, 'last_year_end_with_companies_house')}>
  {item.editing && item.field === 'last_year_end_with_companies_house' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.last_year_end_with_companies_house}
      onBlur={(e) =>
        editField(e.target.value, 'last_year_end_with_companies_house', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.last_year_end_with_companies_house : ''}</span>
  )}
</td>
{user_info.department != 'BookKeeping'?
<td onClick={() => handlemaineditRow(i, 'opening_trial_balance')}>
  {/* {item.editing && item.field === 'opening_trial_balance' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.opening_trial_balance}
      onBlur={(e) =>
        editField(e.target.value, 'opening_trial_balance', item.uid, i)
      }
    />
  ) : (
    <span>{item ? formatCurrency(item.opening_trial_balance) : ''}</span>
  )} */}
  {item.editing && item.field === 'opening_trial_balance' ? (
    <select
      className="form-control"
      onChange={(e) =>
        editField(e.target.value, 'opening_trial_balance', item.uid, i)
      }
      defaultValue={item.opening_trial_balance}
    >
      <option value="0" key="0" style={{ background: '#fff', color: '#000' }}>
        Select
      </option>
      <option value="Yes">Yes</option>
      <option value="No">No</option>
      <option value="NA">NA</option>
    </select>
  ) : (
    <span>{item.opening_trial_balance !=0 ? item.opening_trial_balance : '-'}</span>
  )}
</td>
:null}

<td onClick={() => handlemaineditRow(i, 'current_open_year_end')}>
  {item.editing && item.field === 'current_open_year_end' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.current_open_year_end}
      onBlur={(e) =>
        editField(e.target.value, 'current_open_year_end', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.current_open_year_end : ''}</span>
  )}
</td>
{user_info.department != 'BookKeeping'?
<>
<td onClick={() => handlemaineditRow(i, 'current_open_year_duedate')}>
  {item.editing && item.field === 'current_open_year_duedate' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.current_open_year_duedate}
      onBlur={(e) =>
        editField(e.target.value, 'current_open_year_duedate', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.current_open_year_duedate : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'account_finalised')}>
  {item.editing && item.field === 'account_finalised' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.account_finalised}
      onBlur={(e) =>
        editField(e.target.value, 'account_finalised', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.account_finalised : ''}</span>
  )}
</td>

<td onClick={() => handlemaineditRow(i, 'corient_due_date')}>
  {item.editing && item.field === 'corient_due_date' ? (
    <input
      type="date"
      className="form-control"
      defaultValue={item.corient_due_date}
      onBlur={(e) =>
        editField(e.target.value, 'corient_due_date', item.uid, i)
      }
      disabled={['No', 'no', 'NO'].includes(item.account_finalised)}
    />
  ) : (
    <span>{item ? item.corient_due_date : ''}</span>
  )}
</td></>:null}

                            </tr>
                          </>
                        ) : (
                          <></>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan={3}>No Data Found!</td>
                      </tr>
                    )}
                  </tbody>
                </table> 
                : category=='kpi' ?
                <>
                <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="filter" style={{ padding: '0 1%' }}>
                  <div className="filter" style={{ width: '80%' }}>
                    <div className="col-xl-3 col-md-3 col-xs-12">
                      <h3 className="clientformtag"> Client</h3>
                      <Select
                        className="input-group-alternative mb-3"
                        name="user_id"
                        options={uniquecompanieslist}
                        onChange={(e) => { setclient(e) }}
                        defaultValue={clientsearch}
                        searchable
                        isClearable={false}
                      />
                    </div>
                  
                      <div className="col-xl-3 col-md-3 col-xs-12">
                      <h3 className="clientformtag">Sub Client</h3>
                      <Select
                        className="input-group-alternative mb-3"
                        name="sub_client"
                        options={subclientOptions}
                        value={selectedSubclients}
                        onChange={handleSubclientChange}
                        
                        placeholder="Select Sub Clients"
                      />
                    </div>
                    <div className="col-xl-3 col-md-3 col-xs-12">
                    <br></br>
                     <FormGroup style={{'margin-bottom':0}}>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-calendar-grid-58" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <ReactDatetime
                            inputProps={{
                              placeholder: "Start date"
                            }}
                            timeFormat={false}
                            renderDay={(props, currentDate, selectedDate) => {
                              let classes = props.className;
                              if (
                                state.startDate &&
                                state.endDate &&
                                state.startDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " start-date";
                              } else if (
                                state.startDate &&
                                state.endDate &&
                                new Date(state.startDate._d + "") <
                                  new Date(currentDate._d + "") &&
                                new Date(state.endDate._d + "") >
                                  new Date(currentDate._d + "")
                              ) {
                                classes += " middle-date";
                              } else if (
                                state.endDate &&
                                state.endDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " end-date";
                              }
                              return (
                                <td {...props} className={classes}>
                                  {currentDate.date()}
                                </td>
                              );
                            }}
                            onChange={e => setStartDateRange(e)}
                          />
                        </InputGroup>
                      </FormGroup >
                        </div>
                        <div className="col-xl-3 col-md-3 col-xs-12">
                        <br></br>
                        <FormGroup style={{'margin-bottom':0}}>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-calendar-grid-58" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <ReactDatetime
                            inputProps={{
                              placeholder: "End date"
                            }}
                            timeFormat={false}
                            renderDay={(props, currentDate, selectedDate) => {
                              let classes = props.className;
                              if (
                                state.startDate &&
                                state.endDate &&
                                state.startDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " start-date";
                              } else if (
                                state.startDate &&
                                state.endDate &&
                                new Date(state.startDate._d + "") <
                                  new Date(currentDate._d + "") &&
                                new Date(state.endDate._d + "") >
                                  new Date(currentDate._d + "")
                              ) {
                                classes += " middle-date";
                              } else if (
                                state.endDate &&
                                state.endDate._d + "" === currentDate._d + ""
                              ) {
                                classes += " end-date";
                              }
                              return (
                                <td {...props} className={classes}>
                                  {currentDate.date()}
                                </td>
                              );
                            }}
                            onChange={e => setEndDateRangeCustom(e,0,'date')}
                          />
                        </InputGroup>
                      </FormGroup>
                      </div>
                      <div className="col-xl-3 col-md-3 col-xs-12">
                        <br></br>
                        {(kpiloading == true) ? 
                              <a style={{color:"#2FC3B9"}}>loading.. </a>
                              :
                              <>
                              <div className="d-flex">
                              <Button color="primary" type="button" onClick={syncFilterData} > Sync</Button>
                              <Button color="primary" type="button" onClick={showFilterData} > Show </Button>
                             
                              {formInputData?.data ?
                              <Button color="primary" type="button" onClick={showInsights} > Insights</Button>
                              : null }
                               </div>
                              </>
                        }
                      </div>
                  </div>
                </Row>
              </CardHeader>
            </Card>
            {formInputData?.data  ? (
  <Table className="align-items-center table-flush" responsive>
    <thead  >
      <tr className="blue-row" >
        <th>Ratio</th>
        {columns.map((col, index) => (
          <th key={index}>{col}</th>
        ))}
        <th>YTD</th>
      </tr>
    </thead>
    <tbody>
      <tr className="purple-row" >
        <th colSpan={columns.length + 2}>Profitability Ratios</th>
      </tr>
      {profitabilityRatios.map((ratio, index) => (
        <tr className="orange-row"  key={index}>
          <td>{ratio}</td>
          {columns.map((month, idx) => (
            <td key={idx}>
              {formInputData.data?.[ratio]?.[month] || "-"}
            </td>
          ))}
          <td>{formInputData.data?.[ratio]?.YTD || "-"}</td>
        </tr>
      ))}
      <tr><td></td></tr>
      <tr className="purple-row" >
        <th colSpan={columns.length + 2}>Liquidity Ratios</th>
      </tr>
      {liquidityRatios.map((ratio, index) => (
        <tr className="orange-row" key={index}>
          <td>{ratio}</td>
          {columns.map((month, idx) => (
            <td key={idx}>
              {formInputData.data?.[ratio]?.[month] || "-"}
            </td>
          ))}
          <td>{formInputData.data?.[ratio]?.YTD || "-"}</td>
        </tr>
      ))}
      <tr><td></td></tr>
      <tr className="purple-row" >
        <th colSpan={columns.length + 2}> 	Leverage (Solvency) Ratios</th>
      </tr>
      {leverageRatios.map((ratio, index) => (
        <tr className="orange-row" key={index}>
          <td>{ratio}</td>
          {columns.map((month, idx) => (
            <td key={idx}>
              {formInputData.data?.[ratio]?.[month] || "-"}
            </td>
          ))}
          <td>{formInputData.data?.[ratio]?.YTD || "-"}</td>
        </tr>
      ))}
      <tr><td></td></tr>
       <tr className="purple-row" >
        <th colSpan={columns.length + 2}> 	Efficiency Ratios</th>
      </tr>
      {effieciencyRatios.map((ratio, index) => (
        <tr className="orange-row" key={index}>
          <td>{ratio}</td>
          {columns.map((month, idx) => (
            <td key={idx}>
              {formInputData.data?.[ratio]?.[month] || "-"}
            </td>
          ))}
          <td>{formInputData.data?.[ratio]?.YTD || "-"}</td>
        </tr>
      ))}
      <tr><td></td></tr>
       <tr className="purple-row" >
        <th colSpan={columns.length + 2}> 	Trend Analysis</th>
      </tr>
      {trendAnalysis.map((ratio, index) => (
        <tr className="orange-row" key={index}>
          <td>{ratio}</td>
          {columns.map((month, idx) => (
           <td key={idx}>
           {index == 2 && formInputData.data?.[ratio]?.[month] ? (
             <a style={{color:'blue'}} href={`https://reporting.xero.com/${formInputData.data?.['shortcode']}/v1/Run/1203`} target="_blank">{formInputData.data?.[ratio]?.[month] || "-"}</a>
           ) : index == 3 && formInputData.data?.[ratio]?.[month] ? (
             <a style={{color:'blue'}} href={`https://reporting.xero.com/${formInputData.data?.['shortcode']}/v1/Run/1202`} target="_blank">{formInputData.data?.[ratio]?.[month] || "-"}</a>
           ) : index == 8  && formInputData.data?.[ratio]?.[month] ? (
            <a style={{color:'blue'}} href={`https://reporting.xero.com/${formInputData.data?.['shortcode']}/v1/Run/1217`} target="_blank">{formInputData.data?.[ratio]?.[month] || "-"}</a>
           ) : (
             formInputData.data?.[ratio]?.[month] || "-"
           )}
         </td>
         
          
          ))}
          <td>{formInputData.data?.[ratio]?.YTD || "-"}</td>
        </tr>
      ))}
    </tbody>
  </Table>
) : null }

                </>
                : category=='open_issue'|| category=='close_issue' ?
                <>
                 <table className="align-items-center table-flush sticky-table-client stickytable" responsive>
                  <thead className="red-row" style={{background: "#f6f4f4", borderLeft: "7px solid #737373",borderRadius: "4px 0px 0px 4px"}}>
                  
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Client Name</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Sub-Client Name</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={headerStyle}>Field</th>
                    {/* <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Reason</th> */}
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : manualDataStyle}>Issue Raised</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : manualDataStyle}>End Date</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : manualDataStyle}>Response </th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>Last Followup</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={maincategory=='other' ? manualDataStyle : xeroDataStyle}>No of calls</th>
                   
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Status</th>
                    <th scope="col" className="whitespace sticky-client-column-header" style={manualDataStyle}>Remark</th>

                  </thead>
                  <tbody className="scrollable-content">
                    {openissueData && openissueData.length && data != null ? (
                      openissueData.map((item, i) =>
                        item != undefined ? (
                          <>
                            <tr
                              className={
                                i % 2 == 0
                                  ? "blue-row"
                                  : 
                                   "purple-row"
                                  
                              }
                            >
                              
                            <td className="sticky-client-column">{item.client_name}</td> 
                            <td className="sticky-client-column" >
  {item ? item.name : ''}

</td>
<td>{item.field}</td> 
{/* <td>{item.reason}</td>  */}
<td>{new Date(item.created_at).toLocaleDateString('en-CA')}</td> 
                              {/* <td onClick={() => handleopenissueeditRow(i, 'issue_raised')}>
  {item.editing  ? (
    <input
    type="date"
    className="form-control"
    defaultValue={item.issue_raised}
    onBlur={(e) =>
      editOpenIssueField(e.target.value, 'issue_raised', item.uid, i)
    }
  />
  ) : (
    <span>{item ? item.issue_raised : ''}</span>
  )}
</td> */}

<td onClick={() => handleopenissueeditRow(i, 'end_date')}>
  {item.editing && item.edit_field === 'end_date' ? (
    <input
    type="date"
    className="form-control"
    defaultValue={item.end_date}
    onBlur={(e) =>
      editOpenIssueField(e.target.value, 'end_date', item.id, i)
    }
  />
  ) : (
    <span>{item ? item.end_date : ''}</span>
  )}
</td>



<td onClick={() => handleopenissueeditRow(i, 'response')}>
  {item.editing && item.edit_field === 'response' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.response}
      onBlur={(e) =>
        editOpenIssueField(e.target.value, 'response', item.id, i)
      }
    />
  ) : (
    <span>{item ? item.response : ''}</span>
  )}
</td>

<td onClick={() => handleopenissueeditRow(i, 'last_followup')}>
  {item.editing && item.edit_field === 'last_followup' ? (
    <input
    type="date"
    className="form-control"
    defaultValue={item.last_followup}
    onBlur={(e) =>
      editOpenIssueField(e.target.value, 'last_followup', item.id, i)
    }
  />
  ) : (
    <span>{item ? item.last_followup : ''}</span>
  )}
</td>

<td onClick={() => handleopenissueeditRow(i, 'no_of_calls')}>
  {item.editing && item.edit_field === 'no_of_calls' ? (
    <input
      type="number"
      className="form-control"
      defaultValue={item.no_of_calls}
      onBlur={(e) =>
        editOpenIssueField(e.target.value, 'no_of_calls', item.id, i)
      }
    />
  ) : (
    <span>{item ? item.no_of_calls : ''}</span>
  )}
</td>

{/* <td onClick={() => handleopenissueeditRow(i, 'ma_freq')}>
  {item.editing && item.field === 'ma_freq' ? (
    <input
      type="text"
      className="form-control"
      defaultValue={item.ma_freq}
      onBlur={(e) =>
        editOpenIssueField(e.target.value, 'ma_freq', item.uid, i)
      }
    />
  ) : (
    <span>{item ? item.ma_freq : ''}</span>
  )}
</td> */}



<td onClick={() => handleopenissueeditRow(i, 'status')}>

  {item.editing && item.edit_field === 'status' ? (
    <select
      className="form-control"
      onChange={(e) =>
        editOpenIssueField(e.target.value, 'status', item.id, i)
      }
      defaultValue={item.status}
    >
      <option value="0" key="0" style={{ background: '#fff', color: '#000' }}>
        Select
      </option>
      <option value="1">Open</option>
      <option value="2">Closed</option>
      
    </select>
  ) : (
   
    <span>{item? item.status == 1 ? 'Open': item.status == 2 ? 'Closed' : '' : ''}
    </span>

  )}
</td>
<td onClick={() => handleopenissueeditRow(i, 'remarks')}>
  {item.editing && item.edit_field === 'remarks' ? (
    <input
      type="test"
      className="form-control"
      defaultValue={item.remarks}
      onBlur={(e) =>
        editOpenIssueField(e.target.value, 'remarks', item.id, i)
      }
    />
  ) : (
    <span>{item ? item.remarks : ''}</span>
  )}
</td>





                            </tr>
                          </>
                        ) : (
                          <></>
                        )
                      )
                    ) : (
                      <tr>
                          {(openissueloading == true) ? 
                              <a style={{color:"#2FC3B9"}}  >Loading.. </a> : 
                        <td colSpan={3}>No Data Found!</td>}
                      </tr>
                    )}
                  </tbody>
                </table> 

                </>
                : null
              }
              {(category!='kpi') ?
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
              : null }
            </Card>
          </div>
        </Row>
     </Container>
    </>
  );
};


export default SMEClients;
